import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  Client,
  ClientForm,
  ClientList,
  ClientListItem,
  ClientListResponse,
  ClientProfile,
  CreateClientPayload,
  FetchClientsQueryParam,
} from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private _apiUrl = environment.apiUrl;
  private _http = inject(HttpClient);
  private _authHeaders = new HttpHeaders({
    Authorization: '',
  });

  public getClients(): Observable<Client[]> {
    return this._http.get<Client[]>('assets/mock-data/clients-data.json');
  }

  public fetchClients(
    queryParams?: Partial<FetchClientsQueryParam>
  ): Observable<ClientList> {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value) {
          params = params.set(key, value);
        }
      });
    }

    return this._http
      .get<ClientListResponse>(`${this._apiUrl}/api/client/list`, {
        headers: this._authHeaders,
        params,
      })
      .pipe(
        map((resp) => {
          const clientList: ClientList = {
            pagination: resp.pagination,
            client_list: resp.client_list.map((clientResponse) => {
              const client: ClientListItem = {
                commerce: clientResponse?.commerce ?? '',
                email: clientResponse?.email ?? '',
                fullname: clientResponse?.fullname ?? '',
                id: clientResponse?.id ?? null,
                institution: clientResponse?.institution ?? '',
                profile: clientResponse?.profile ?? '',
                status: clientResponse?.status ?? '',
              };
              return client;
            }),
          };
          return clientList;
        })
      );
  }

  public createClient(clientForm: ClientForm): Observable<any> {
    const payload: CreateClientPayload = {
      firstname: clientForm.name,
      lastname: clientForm.surname,
      address: clientForm.address,
      commerce_id: clientForm.commerceId,
      email: clientForm.email,
      id_number: Number(clientForm.dni),
      phone_number: Number(clientForm.phone),
      profile: clientForm.profile ? clientForm.profile : ClientProfile.Médico,
    };

    return this._http.post<any>(
      `${this._apiUrl}/api/client/register`,
      payload,
      { headers: this._authHeaders }
    );
  }
}
